module.exports = __webpack_public_path__ + "img/16.ec10e699.png";